"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Pivot_NextButton: "Next",
                Pivot_NextTab: "Move to the next tab",
                Pivot_PreviousButton: "Previous",
                Pivot_PrevTab: "Move to the previous tab",
            }
        });
        /**
         * Concrete implementation of the Pivot.
         */
        var Pivot = /** @class */ (function (_super) {
            __extends(Pivot, _super);
            function Pivot() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Pivot.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                var $element = $(element);
                var tabList;
                var nextButton;
                var prevButton;
                var isButtonRTL = false;
                var touchDown = false;
                var timingQuick = 167;
                var scrollStep = 100;
                var repeatingScrollTimer;
                var repeatingScrollDelay = 200;
                var mousedown = false;
                var _asyncOverflowProcess;
                this._defineVariables = function () {
                    if (_this.element) {
                        tabList = tabList || _this.element.querySelector(".pivot-list");
                        // in RTL mode we need to flip the concept of next and previous around, also reset if we are going from ltr to rtl
                        if ($dyn.util.isRTLMode() && !isButtonRTL) {
                            if (!isButtonRTL) {
                                nextButton = undefined;
                                prevButton = undefined;
                                isButtonRTL = true;
                            }
                            nextButton = nextButton || _this.element.querySelector(".pivot-listOverflowPrevious");
                            prevButton = prevButton || _this.element.querySelector(".pivot-listOverflowNext");
                        }
                        else {
                            nextButton = nextButton || _this.element.querySelector(".pivot-listOverflowNext");
                            prevButton = prevButton || _this.element.querySelector(".pivot-listOverflowPrevious");
                        }
                    }
                };
                this._updateOverflow = function () {
                    _this._defineVariables();
                    if (tabList !== undefined && tabList !== null) {
                        var contentWidth = tabList.scrollWidth;
                        var tabListWidth = tabList.offsetWidth;
                        var scroll_1 = tabList.scrollLeft;
                        if (contentWidth !== 0) {
                            if (tabListWidth < contentWidth) {
                                $element.addClass("pivot-list-hasOverflow");
                                if (scroll_1 === 0) {
                                    prevButton.setAttribute("disabled", "true");
                                    nextButton.removeAttribute("disabled");
                                }
                                else if (scroll_1 >= (contentWidth - tabListWidth - 1)) {
                                    nextButton.setAttribute("disabled", "true");
                                    prevButton.removeAttribute("disabled");
                                }
                                else {
                                    nextButton.removeAttribute("disabled");
                                    prevButton.removeAttribute("disabled");
                                }
                            }
                            else {
                                $element.removeClass("pivot-list-hasOverflow");
                                $(tabList).animate({ scrollLeft: 0 }, timingQuick);
                            }
                        }
                    }
                };
                this._scrollTablistRight = function () {
                    _this._defineVariables();
                    var contentWidth = tabList.scrollWidth;
                    var tabListWidth = tabList.offsetWidth;
                    var maximumScroll = contentWidth - tabListWidth - scrollStep;
                    var scroll = tabList.scrollLeft;
                    if (scroll < maximumScroll) {
                        scroll = scroll + scrollStep;
                        $(tabList).animate({ scrollLeft: scroll }, timingQuick);
                        prevButton.removeAttribute("disabled");
                    }
                    else if (scroll >= maximumScroll) {
                        scroll = contentWidth - tabListWidth;
                        $(tabList).animate({ scrollLeft: scroll }, timingQuick);
                        if (!mousedown) {
                            nextButton.setAttribute("disabled", "true");
                            prevButton.removeAttribute("disabled");
                        }
                    }
                };
                this._scrollTablistLeft = function () {
                    _this._defineVariables();
                    var scroll = tabList.scrollLeft;
                    if (scroll > scrollStep) {
                        scroll = scroll - scrollStep;
                        $(tabList).animate({ scrollLeft: scroll }, timingQuick);
                        nextButton.removeAttribute("disabled");
                    }
                    else {
                        if (!mousedown) {
                            prevButton.setAttribute("disabled", "true");
                            nextButton.removeAttribute("disabled");
                        }
                        $(tabList).animate({ scrollLeft: 0 }, timingQuick);
                    }
                };
                this._updateScrollLoc = function () {
                    _this._defineVariables();
                    var contentWidth = tabList.scrollWidth;
                    var tabListWidth = tabList.offsetWidth;
                    if (touchDown) {
                        var newScrollLoc = $(tabList).scrollLeft();
                        var scroll_2 = newScrollLoc;
                        if ((scroll_2 + tabListWidth) < contentWidth) {
                            prevButton.removeAttribute("disabled");
                            nextButton.removeAttribute("disabled");
                            if (scroll_2 <= (scrollStep / 4)) {
                                prevButton.setAttribute("disabled", "true");
                            }
                        }
                        else {
                            nextButton.setAttribute("disabled", "true");
                        }
                    }
                };
                this._mouseWheelScroll = function (e) {
                    _this._defineVariables();
                    e = window.event || e;
                    var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
                    var scroll = tabList.scrollLeft;
                    var contentWidth = tabList.scrollWidth;
                    var tabListWidth = tabList.offsetWidth;
                    var maxScroll = contentWidth - tabListWidth - 1;
                    scroll = scroll + delta * scrollStep;
                    $(tabList).animate({ scrollLeft: scroll }, timingQuick);
                    if (scroll <= 0) {
                        prevButton.setAttribute("disabled", "true");
                        nextButton.removeAttribute("disabled");
                    }
                    else if (scroll < maxScroll) {
                        prevButton.removeAttribute("disabled");
                        nextButton.removeAttribute("disabled");
                    }
                    else {
                        nextButton.setAttribute("disabled", "true");
                    }
                    event.preventDefault();
                };
                this._manualScrollOn = function () {
                    touchDown = true;
                };
                this._manualScrollOff = function () {
                    touchDown = false;
                };
                this._mouseDownRight = function () {
                    mousedown = true;
                    repeatingScrollTimer = window.setInterval(function () {
                        _this._scrollTablistRight();
                    }, repeatingScrollDelay);
                };
                this._mouseDownLeft = function () {
                    mousedown = true;
                    repeatingScrollTimer = window.setInterval(function () {
                        _this._scrollTablistLeft();
                    }, repeatingScrollDelay);
                };
                this._mouseUp = function () {
                    mousedown = false;
                    clearInterval(repeatingScrollTimer);
                };
                /**
                 * Handler for when the Pivot reflows.
                 */
                var reflowHandler = function () {
                    if (_asyncOverflowProcess) {
                        _asyncOverflowProcess.cancel();
                    }
                    _asyncOverflowProcess = $dyn.async(function () {
                        _this._updateOverflow();
                        _asyncOverflowProcess = undefined;
                    });
                };
                this.usingDisposable($dyn.layout.registerEndReflowHandler(this.element, reflowHandler));
                $(window).on("resize", this._updateOverflow);
                if (tabList !== undefined && tabList !== null) {
                    tabList.addEventListener("touchstart", this._manualScrollOn);
                    tabList.addEventListener("touchend", this._manualScrollOff);
                    tabList.addEventListener("mousewheel", this._mouseWheelScroll);
                    $(tabList).on("scroll", this._updateScrollLoc);
                }
                this.headerKeyDown = function (evt) {
                    var nextTabKeyCode = $dyn.util.isRTLMode() ? $dyn.ui.KeyCodes.leftArrow : $dyn.ui.KeyCodes.rightArrow;
                    var prevTabKeyCode = $dyn.util.isRTLMode() ? $dyn.ui.KeyCodes.rightArrow : $dyn.ui.KeyCodes.leftArrow;
                    var stopProp = false;
                    if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: nextTabKeyCode })) {
                        _this.ChangeTabHeaderFocus(1);
                        stopProp = true;
                    }
                    else if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: prevTabKeyCode })) {
                        _this.ChangeTabHeaderFocus(-1);
                        stopProp = true;
                    }
                    else if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.enter })) {
                        var focusedItem = _this.FocusedItem();
                        if (focusedItem) {
                            focusedItem.Activate();
                        }
                    }
                    else {
                        _this.keyDown(evt);
                    }
                    if (stopProp && evt && evt.stopPropagation) {
                        evt.stopPropagation();
                    }
                };
            };
            Pivot.prototype.dispose = function () {
                $(window).off("resize", this._updateOverflow);
                if (this.element) {
                    var tabList = this.element.querySelector(".pivot-list");
                    if (tabList) {
                        tabList.removeEventListener("touchstart", this._manualScrollOn);
                        tabList.removeEventListener("touchend", this._manualScrollOff);
                        tabList.removeEventListener("mousewheel", this._mouseWheelScroll);
                        $(tabList).off("scroll", this._updateScrollLoc);
                    }
                }
                _super.prototype.dispose.call(this);
            };
            /**
             * Scrolls the Pivot's tab right when there is overflow.
             */
            Pivot.prototype.MoveRight = function () {
                if ($dyn.util.isRTLMode()) {
                    this._scrollTablistLeft();
                }
                else {
                    this._scrollTablistRight();
                }
            };
            /**
             * Scrolls the Pivot's tab left when there is overflow.
             */
            Pivot.prototype.MoveLeft = function () {
                if ($dyn.util.isRTLMode()) {
                    this._scrollTablistRight();
                }
                else {
                    this._scrollTablistLeft();
                }
            };
            /**
             * Triggers the Pivot to scroll its tabs continuously to the right.
             */
            Pivot.prototype.MoveRightContinue = function () {
                if ($dyn.util.isRTLMode()) {
                    this._mouseDownLeft();
                }
                else {
                    this._mouseDownRight();
                }
            };
            /**
             * Triggers the Pivot to scroll its tabs continuously to the left.
             */
            Pivot.prototype.MoveLeftContinue = function () {
                if ($dyn.util.isRTLMode()) {
                    this._mouseDownRight();
                }
                else {
                    this._mouseDownLeft();
                }
            };
            /**
             * Stops the Pivot from scrolling left or right.
             */
            Pivot.prototype.MouseUp = function () {
                this._mouseUp();
            };
            return Pivot;
        }(controls.PivotBase));
        controls.Pivot = Pivot;
        // tslint:disable:object-literal-sort-keys
        var pivotShortcuts = {
            RightTab: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.rightArrow },
                Handler: function () {
                    var dir = $dyn.util.isRTLMode() ? -1 : 1;
                    return this.NavigateTab(dir);
                },
                ShowToUser: function () { return $dyn.value(this.ShowHeaders); },
                Description: function () {
                    return $dyn.util.isRTLMode() ? $dyn.label("Pivot_PrevTab") : $dyn.label("Pivot_NextTab");
                },
                Category: $dyn.ui.ShortcutCategory.Navigate
            },
            LeftTab: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.leftArrow },
                Handler: function () {
                    var dir = $dyn.util.isRTLMode() ? 1 : -1;
                    return this.NavigateTab(dir);
                },
                ShowToUser: function () { return $dyn.value(this.ShowHeaders); },
                Description: function () {
                    return $dyn.util.isRTLMode() ? $dyn.label("Pivot_NextTab") : $dyn.label("Pivot_PrevTab");
                },
                Category: $dyn.ui.ShortcutCategory.Navigate
            }
        };
        Pivot.prototype.Shortcuts = $dyn.extendPrototype(Pivot.prototype.Shortcuts, pivotShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Pivot.js.map
